<template>
	<div>
		<RoomHeader msg="My Infinity"></RoomHeader>
		<p>Tous nos techniciens sont occupés. Nous mettons tout en oeuvre pour vous répondre au plus vite.</p>
	</div>
</template>

<script>
import RoomHeader from './RoomHeader'
export default {
  name: 'TicketError',
  components: {RoomHeader}

}
</script>

<style lang="scss" scoped>

</style>